import { Button } from '@mui/material';
import { toggleGeoLicenses } from '../../api/analyzerModules';
import { useIsSuperUser } from '../auth/hooks/useIsSuperUser';
import { queryClient } from 'lib/react-query';
import { useAnalyzerModules } from 'features/analyzerModules/api/getAnalyzerModules';

const ToggleLicensesButton = () => {
  const { data: modules } = useAnalyzerModules({});
  const geoLicensesEnabled = modules?.some(
    (module) => !module.types.some((type) => type === 'GEO-REMOVED')
  );

  const isSuperUser = useIsSuperUser();

  const handleClicked = async () => {
    await toggleGeoLicenses();
    queryClient.invalidateQueries(['analyzers']);
    queryClient.invalidateQueries(['analyzerModules']);
  };

  if (!(process.env.REACT_APP_MODE === 'LPT' && isSuperUser)) {
    return <></>;
  }

  if (geoLicensesEnabled) {
    return (
      <Button onClick={handleClicked} variant='contained' color='primary'>
        Disable GEO Licenses
      </Button>
    );
  } else {
    return (
      <Button onClick={handleClicked} variant='contained' color='primary'>
        Enable GEO Licenses
      </Button>
    );
  }
};

export default ToggleLicensesButton;
